import { render, staticRenderFns } from "./PagePreviewVideo.vue?vue&type=template&id=f6111df4"
import script from "./PagePreviewVideo.vue?vue&type=script&lang=js"
export * from "./PagePreviewVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports